import { logger } from "./logger";
import memStore from "./memStore";

export const glideLocalStorage = {
  async getItem(key: string): Promise<string | null> {
    const didProvideLocalStorage =
      memStore.getItem("didProvideLocalStorage") === "true";

    if (!didProvideLocalStorage) {
      logger.info(`Reading browser local storage: ${key}`, {
        key: "glideLocalStorage.read",
      });
      return window.localStorage.getItem(key);
    }

    return new Promise<string | null>((resolve) => {
      const handleMessage = (event: MessageEvent) => {
        if (
          event.data &&
          event.data.type === "localStorage.didGetItem" &&
          event.data.key === key
        ) {
          window.removeEventListener("message", handleMessage);
          resolve(event.data.value);
        }
      };

      window.addEventListener("message", handleMessage);

      window.parent?.postMessage({ type: "localStorage.getItem", key }, "*");
    });
  },
  async setItem(key: string, value: string): Promise<void> {
    const didProvideLocalStorage =
      memStore.getItem("didProvideLocalStorage") === "true";

    if (!didProvideLocalStorage) {
      logger.info(`Setting browser local storage: ${key}, ${value}`, {
        key: "glideLocalStorage.write",
      });
      window.localStorage.setItem(key, value);
      return;
    }

    window.parent?.postMessage(
      { type: "localStorage.setItem", key, value },
      "*",
    );
  },
  async removeItem(key: string): Promise<void> {
    const didProvideLocalStorage =
      memStore.getItem("didProvideLocalStorage") === "true";

    if (!didProvideLocalStorage) {
      window.localStorage.removeItem(key);
      return;
    }

    window.parent?.postMessage({ type: "localStorage.removeItem", key }, "*");
  },
  async getKeys(): Promise<string[]> {
    const didProvideLocalStorage =
      memStore.getItem("didProvideLocalStorage") === "true";

    if (!didProvideLocalStorage) {
      return Object.keys(window.localStorage);
    }

    return new Promise<string[]>((resolve) => {
      const handleMessage = (event: MessageEvent) => {
        if (event.data && event.data.type === "localStorage.didGetKeys") {
          window.removeEventListener("message", handleMessage);
          resolve(event.data.keys);
        }
      };

      window.addEventListener("message", handleMessage);

      window.parent?.postMessage({ type: "localStorage.getKeys" }, "*");
    });
  },
};
